'use client';

import { Box, Flex } from "@chakra-ui/react";
import Container from '@/components/partials/Container';
import { LuSearch, LuMenu, LuEllipsisVertical } from "react-icons/lu"
import Logo from "./Logo"
import Search from "./Search"
import ResponsiveMenu from "./ResponsiveMenu"
import { useState } from "react";

export default function BaseMenu({ categories, scrolled }) {
  const [openedMenu, setOpenedMenu] = useState(false);
  const [openedSearch, setOpenedSearch] = useState(false);

  function handleMenuToggle() {
    setOpenedMenu(!openedMenu);
  };

  function handleSearchToggle() {
    setOpenedSearch(!openedSearch);
  };

  const logo = {
    base: '120px',
    md: '160px'
  }

  const icons = {
    base: '1.6em',
    md: '2.4em'
  }

  return (
    <>
    <Container>
      <Flex justifyContent={{ base: 'space-between', sm: 'space-between' }} alignItems={{ base: 'center', xl: 'end' }}>
        <Flex w="100%" justifyContent={{ base: 'space-between', lg: 'space-between' }} alignItems="center">
          <Box fontSize={{ base: icons.base, md: scrolled === true ? icons.base : icons.md }} cursor="pointer" onClick={() => handleMenuToggle()}>
            { openedMenu ? <LuEllipsisVertical /> : <LuMenu /> }
          </Box>

          <Box w="100%" transition="all .5s ease-in-out" maxW={{ base: logo.base, md: scrolled === true ? logo.base : logo.md }}>
            <Logo />
          </Box>

          <Box fontSize={{ base: icons.base, md: scrolled === true ? icons.base : icons.md }} cursor="pointer" onClick={() => handleSearchToggle()}>
            <LuSearch />
          </Box>
        </Flex>
      </Flex>

      <Box>
        <ResponsiveMenu categories={categories} openedMenu={openedMenu} handleMenuToggle={handleMenuToggle} />
      </Box>

       <Box>
        <Search openedSearch={openedSearch} handleSearchToggle={handleSearchToggle} />
      </Box>
    </Container>
  </>
  )
}
